// Free-function reimplementations of derived/method members that don't survive
// kotlinx-serialization (Customer.fullName, CommentForContest.isAMatch, etc.)
// and a couple of helpers for narrowing sealed-union payloads.

import {
  Comment,
  CommentForContest,
  ContestManagement,
  ContestManagementDisc,
  Customer,
  CustomerDisc,
  EventPayload,
} from "./generated/core-types";

export const fullName = (c: Customer): string =>
  c.type === CustomerDisc.FacebookUser ? c.name : "<No user>";

export const isAMatch = (c: CommentForContest): boolean => c.score >= 0.9;

export const commentKey = (c: Comment): string => `${c.commentId}_${c.item}`;

export const sameComment = (a: Comment, b: Comment): boolean =>
  a.commentId === b.commentId && a.item === b.item;

export const sameUser = (a: Customer, b: Customer): boolean => {
  if (a.type !== b.type) return false;
  if (a.type === CustomerDisc.FacebookUser && b.type === CustomerDisc.FacebookUser) {
    return a.id === b.id;
  }
  return true;
};

export const contestOngoing = (contest: ContestManagement): boolean =>
  contest.type !== ContestManagementDisc.NoContest;

export function narrowPayload<T extends EventPayload["type"]>(
  payload: EventPayload,
  type: T,
): Extract<EventPayload, { type: T }> | null {
  return payload.type === type ? (payload as Extract<EventPayload, { type: T }>) : null;
}
